import { SOURCE_TYPES } from 'constants/source'

export function isMetasearchRateSource(source?: string): boolean {
  const sourceTypes = source?.split(',') ?? []

  return sourceTypes.includes(SOURCE_TYPES.METASEARCH) || sourceTypes.includes(SOURCE_TYPES.CUG_METASEARCH)
}
